import { formatPhoneNumber } from "@/app/utils/formatPhoneNumber";
import { getNameInitial } from "@/app/utils/getNameInitial";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@/view/components/ui/avatar";
import { Button } from "@/view/components/ui/button";
import useCreditFooterController from "./useCreditFooter";

export function CreditFooter() {
  const { seller, handleWhatsAppClick } = useCreditFooterController()
  if (!seller) return

  return (
    <div className="w-full border-t-2 p-3 border-white">
      <div className="max-w-lg mx-auto px-6 flex flex-col md:flex-row gap-2 items-center justify-between">
        <div className="flex items-center gap-2">
          <Avatar className="h-12 w-12 border-2 border-white">
            <AvatarImage
              src={
                seller?.profileImageUrl
                  ? `${import.meta.env.VITE_CDN_URL}${seller?.profileImageUrl}`
                  : undefined
              }
            />
            <AvatarFallback
              className="text-sm bg-primary text-white font-bold"
            >
              {getNameInitial(seller?.name || "")}
            </AvatarFallback>
          </Avatar>

          <div className="text-xs">
            <p className="text-gray-500 text-[10px]">Você está sendo atendido por:</p>
            <p className="font-semibold">{seller?.name}</p>
            <p>{formatPhoneNumber(seller?.phone || "")}</p>
          </div>
        </div>


        <Button
          className="h-8 text-white text-xs rounded-lg"
          onClick={handleWhatsAppClick}>Chamar no WhatsApp</Button>
      </div>
    </div>
  )
}